import { chainConfigs } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { Button, Icon } from 'ui-framework'
import CompensationVM, { BscCompensationTab } from '../CompensationVM'
import BZRXCompensationBSCInfo from './BZRXCompensationBSCInfo'
import BZRXCompensationBSCStep1 from './BZRXCompensationBSCStep1'
import BZRXCompensationBSCStep2 from './BZRXCompensationBSCStep2'

const tabs: {
  id: BscCompensationTab
  label: string
  chainIcon: { name: string; color: string }
}[] = [
  { id: 'bsc', label: '1. Send BZRX on BSC', chainIcon: chainConfigs[56].icon },
  { id: 'polygon', label: '2. Claim on Polygon', chainIcon: chainConfigs[137].icon },
]

export function BZRXCompensationBSC({ vm }: { vm: CompensationVM }) {
  return (
    <div className="grid-fluid-colmin-22em">
      <BZRXCompensationBSCInfo />

      <div className="panel--simple md-padded-2">
        <h3 className="panel__header title-section flex-row-center">
          <Icon name="token-bzrx" size={24} />
          <span className="margin-left-1ch">BZRX Compensation</span>
        </h3>

        {vm.bscTab === '' && (
          <>
            <ul className="list-spaced-1 margin-bottom-2">
              <li>Choose option 1 if you have BZRX on BSC.</li>
              <li>Choose option 2 if you did step 1 already.</li>
            </ul>
            <div className="flex-row-center justify-between flex-wrap">
              {tabs.map((tab) => (
                <Button
                  key={tab.id}
                  className="flex-row-center"
                  variant="neutral"
                  onClick={vm.changeBscTab}
                  onClickEmit="value"
                  value={tab.id}>
                  <Icon name={tab.chainIcon.name} size={24} color={tab.chainIcon.color} />
                  <span className="margin-left-1ch">{tab.label}</span>
                </Button>
              ))}
            </div>
          </>
        )}
        {vm.bscTab !== '' && (
          <>
            <Button
              variant="link"
              className="flex-row-center margin-bottom-2"
              onClick={vm.changeBscTab}
              onClickEmit="value"
              value="">
              <Icon name="caret-left" size={16} /> <span className="margin-left-05">Back</span>
            </Button>

            {vm.bscTab === 'bsc' && <BZRXCompensationBSCStep1 vm={vm} />}
            {vm.bscTab === 'polygon' && <BZRXCompensationBSCStep2 vm={vm} />}
          </>
        )}
      </div>
    </div>
  )
}

export default observer(BZRXCompensationBSC)
